import CMSPage from "@/components/CMSPage";
import { Truck } from "lucide-react";

export default function MovingCostCalculatorPage() {
  return (
    <CMSPage
      pageId="moving-cost-calculator"
      defaultTitle="Moving Cost Calculator"
      defaultDescription="Budget for your move with our comprehensive cost calculator. Factor in stamp duty, legal fees, removal costs, and more to plan your move effectively."
      icon={Truck}
    />
  );
}
